import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <Box
      sx={{
        background: "#FFE9BA",
        py: 8,
        color: 'black',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography variant="h4" sx={{ mb: 2 }}>
            Ready to Unlock Your Inner World?
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Start exploring your dreams and mindfulness journey today.
          </Typography>
          <Button variant="contained" color="secondary" size="large" href="/download">
            Get MindMapper AI
          </Button>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CTASection;
